import { render, staticRenderFns } from "./AssuranceRequirementSuggestion.vue?vue&type=template&id=0463feb6"
import script from "./AssuranceRequirementSuggestion.vue?vue&type=script&lang=js"
export * from "./AssuranceRequirementSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports